module.exports = __webpack_public_path__ + "static/img/mesa-trabalho.c841e41.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mesa-trabalho.jpg
// module id = bK53
// module chunks = 1